"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CellSummaryModule = void 0;
const tslib_1 = require("tslib");
const AdaptableModuleBase_1 = require("./AdaptableModuleBase");
const ModuleConstants = tslib_1.__importStar(require("../Utilities/Constants/ModuleConstants"));
const ArrayExtensions_1 = require("../Utilities/Extensions/ArrayExtensions");
const Helper_1 = require("../Utilities/Helpers/Helper");
const CellSummaryStatusPanel_1 = require("../View/CellSummary/CellSummaryStatusPanel");
class CellSummaryModule extends AdaptableModuleBase_1.AdaptableModuleBase {
    constructor(api) {
        super(ModuleConstants.CellSummaryModuleId, ModuleConstants.CellSummaryFriendlyName, 'cells', 'CellSummaryPopup', 'See summary information on a group of cells using multiple summary operations', api);
    }
    getViewAccessLevel() {
        return 'Full';
    }
    addColumnMenuItems(column) {
        if (!this.isModuleAvailable()) {
            return;
        }
        return [
            this.createCellSummaryMenuItem({
                source: 'ColumnMenu',
                column,
            }),
        ];
    }
    addContextMenuItems(menuContext) {
        if (!this.isModuleAvailable()) {
            return;
        }
        if (menuContext.adaptableColumn && menuContext.isSelectedCell) {
            return [
                this.createCellSummaryMenuItem({
                    source: 'ContextMenu',
                }),
            ];
        }
    }
    createCellSummaryMenuItem(popUpParams) {
        return this.createMainMenuItemShowPopup({
            Label: 'See Cell Summary',
            ComponentName: this.moduleInfo.Popup,
            Icon: this.moduleInfo.Glyph,
            PopupParams: popUpParams,
        });
    }
    createCellSummary(selectedCellInfo) {
        let selectedCellSummary;
        if (selectedCellInfo && ArrayExtensions_1.ArrayExtensions.IsNotNullOrEmpty(selectedCellInfo.columns)) {
            let numericValues = [];
            let allValues = [];
            let numericColumns = [];
            selectedCellInfo.columns.map((c) => {
                if (c && c.dataType == 'Number') {
                    numericColumns.push(c.columnId);
                }
            });
            selectedCellInfo.gridCells.forEach((selectedCell) => {
                let value = selectedCell.rawValue;
                allValues.push(value);
                if (!selectedCell.column) {
                    // GridCell.column may be undefined for cells from synthetic columns created by AG Grid (ex. autoGroup columns)
                    return;
                }
                if (ArrayExtensions_1.ArrayExtensions.ContainsItem(numericColumns, selectedCell.column.columnId)) {
                    let valueAsNumber = Number(value);
                    // possible that its not a number despite it being a numeric column
                    if (!isNaN(Number(valueAsNumber))) {
                        numericValues.push(valueAsNumber);
                    }
                }
            });
            // copying so that we keep the order - needed for others
            const newNumericValues = [...numericValues];
            let hasNumericColumns = numericValues.length > 0;
            let distinctCount = ArrayExtensions_1.ArrayExtensions.RetrieveDistinct(allValues).length;
            selectedCellSummary = {
                Sum: hasNumericColumns
                    ? Helper_1.Helper.roundNumberTo4dp(Helper_1.Helper.sumNumberArray(numericValues))
                    : undefined,
                Average: hasNumericColumns
                    ? Helper_1.Helper.roundNumberTo4dp(Helper_1.Helper.meanNumberArray(numericValues))
                    : undefined,
                Median: hasNumericColumns
                    ? Helper_1.Helper.roundNumberTo4dp(Helper_1.Helper.medianNumberArray(numericValues))
                    : undefined,
                Mode: hasNumericColumns
                    ? Helper_1.Helper.roundNumberTo4dp(Helper_1.Helper.modeNumberArray(numericValues))
                    : undefined,
                Distinct: distinctCount,
                Max: hasNumericColumns ? Helper_1.Helper.roundNumberTo4dp(Math.max(...numericValues)) : undefined,
                Min: hasNumericColumns ? Helper_1.Helper.roundNumberTo4dp(Math.min(...numericValues)) : undefined,
                Count: allValues.length,
                Std_Deviation: hasNumericColumns
                    ? Helper_1.Helper.roundNumberTo4dp(Helper_1.Helper.standardDeviationNumberArray(numericValues))
                    : undefined,
                Only: distinctCount == 1 ? JSON.stringify(allValues[0]) : '',
            };
            numericValues = [...newNumericValues];
            const operationDefinitions = this.api.cellSummaryApi.getCellSummaryOperationDefinitions();
            const api = this.api;
            operationDefinitions === null || operationDefinitions === void 0 ? void 0 : operationDefinitions.forEach((operation) => {
                if (operation.operationFunction) {
                    const cellSummaryOperationContext = {
                        selectedCellInfo,
                        distinctCount,
                        allValues,
                        numericValues,
                        numericColumns,
                        adaptableApi: this.api,
                        userName: this.api.optionsApi.getUserName(),
                        adaptableId: this.api.optionsApi.getAdaptableId(),
                    };
                    selectedCellSummary[operation.operationName] = operation.operationFunction(cellSummaryOperationContext);
                }
            });
        }
        return selectedCellSummary;
    }
    getViewProperties() {
        return {
            getStatusBarPanelProps() {
                /**
                 * This uses a custom view because it has special logic to
                 * trigger summary operations when the component is rendered.
                 */
                return {
                    view: CellSummaryStatusPanel_1.CellSummaryStatusPanel,
                };
            },
        };
    }
}
exports.CellSummaryModule = CellSummaryModule;
